import { debug } from '../../../utils';
const commonDelimiters = [' - ', ' | ', ': '];
const streamTitleRegex = /StreamTitle='([\s\S]*?)';/;
const adBreakIndicator = 'adw_ad=';
const ICY_METADATA_DELAY_MS = 10_000;
const icyAdBreakTitles = {
    TIADSTART: true,
    TIADMID: true,
    TIADEND: true,
};
export function parseIcyMetadata(metadata, setIcyDelay = false) {
    debug('Parsing Icy metadata', metadata);
    const transformedMetadata = {
        title: '',
        subtitle: '',
        isAdBreak: metadata.includes(adBreakIndicator),
        delayMs: setIcyDelay ? ICY_METADATA_DELAY_MS : 0,
    };
    if (transformedMetadata.isAdBreak) {
        debug('Parsed Icy metadata', transformedMetadata);
        return transformedMetadata;
    }
    const streamTitleMatch = streamTitleRegex.exec(metadata);
    if (!streamTitleMatch) {
        return transformedMetadata;
    }
    const streamTitle = streamTitleMatch[1] || '';
    for (const delimiter of commonDelimiters) {
        if (!streamTitle.includes(delimiter)) {
            continue;
        }
        const [title, subtitle] = streamTitle.split(delimiter) || [];
        transformedMetadata.title = title?.trim() || '';
        transformedMetadata.subtitle = subtitle?.trim() || '';
        break;
    }
    // If no delimiter is found, treat the entire string as the title
    if (!transformedMetadata.title && streamTitle?.trim().length) {
        transformedMetadata.title = streamTitle.trim();
    }
    if (icyAdBreakTitles[transformedMetadata.title]) {
        transformedMetadata.isAdBreak = true;
    }
    debug('Parsed Icy metadata', transformedMetadata);
    return transformedMetadata;
}
